<template>
	<div class="stories-main-wrapper" v-if="isStoriesActive" @click="closeStories">
		<div ref="wrapperContent" class="stories-main-wrapper__content">
			<StoriesMainSlider ref="storiesMainSlider" />
		</div>
	</div>
</template>

<script>
import StoriesMainSlider from '@/components/dashboard/Stories/Main/StoriesMainSlider.vue';
import { mapState, mapMutations } from 'vuex';

export default {
	components: {
		StoriesMainSlider
	},

	computed: {
		...mapState({
			isStoriesActive: state => state.news.isStoriesActive
		}),

	},

	methods: {
		...mapMutations({
			showStory: 'news/showStory',
			setStoryIndex: 'news/setStoryIndex'
		}),

		closeStories(e) {
			// закрываем только при клике по overlay (фон)
			if (e && e.target !== e.currentTarget) return;

			const slider = this.$refs.storiesMainSlider;
			if (slider && typeof slider.closeStory === 'function') {
				slider.closeStory();
			} else {
				this.showStory(false)
				this.setStoryIndex(null)
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.stories-main-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	background-color: rgba(#000, 0.8);
	z-index: 999;

	&__content {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		overflow: hidden;
	}
}
</style>